export default "__VITE_ASSET__MvRT3qo2__"